import { useState, useEffect } from 'react';

const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const header = document.getElementById('header');
    if (header) {
      const updateHeaderHeight = () => {
        const newHeight = header.offsetHeight;
        setHeaderHeight(newHeight);
      };

      const resizeObserver = new ResizeObserver(() => {
        updateHeaderHeight();
      });

      resizeObserver.observe(header);

      // Initial update
      updateHeaderHeight();

      // Force update on layout changes (e.g., when Alert appears/disappears)
      // Use MutationObserver to detect DOM changes that might affect layout
      const mutationObserver = new MutationObserver(() => {
        // Use requestAnimationFrame to ensure layout has settled
        requestAnimationFrame(() => {
          updateHeaderHeight();
        });
      });

      // Observe changes in the document body that might affect layout
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });

      // Also listen to window resize events
      const handleResize = () => {
        updateHeaderHeight();
      };
      window.addEventListener('resize', handleResize);

      return () => {
        resizeObserver.unobserve(header);
        mutationObserver.disconnect();
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return headerHeight;
};

export default useHeaderHeight;